import { defineMessages } from 'react-intl';

export const scope = 'app.components.QuickOrder';

export default defineMessages({
  inputPlaceholder: {
    id: `${scope}.inputPlaceholder`,
    defaultMessage: 'Dán danh sách hoặc hình ảnh vào đây.\nVD: Thịt bò 2kg, cà chua 500g, nước mắm 3 chai 1L',
  },
  inputPlaceholderWithImage: {
    id: `${scope}.inputPlaceholderWithImage`,
    defaultMessage: 'Có thể thêm ghi chú',
  },
  uploadImage: {
    id: `${scope}.uploadImage`,
    defaultMessage: 'Tải ảnh lên',
  },
  supportHint: {
    id: `${scope}.supportHint`,
    defaultMessage: 'Nhập, dán nội dung/ảnh hoặc tải tối đa 3 ảnh (JPG, PNG, WEBP < 10MB)',
  },
  pageSubtitle: {
    id: `${scope}.pageSubtitle`,
    defaultMessage: 'Nhập, dán hoặc tải ảnh – AI tự nhận diện và gợi ý sản phẩm thêm nhanh vào giỏ hàng.',
  },
  analyzing: {
    id: `${scope}.analyzing`,
    defaultMessage: 'AI đang phân tích....',
  },
  analyzingSubtext: {
    id: `${scope}.analyzingSubtext`,
    defaultMessage: 'Đọc danh sách và tìm sản phẩm...',
  },
  resultBanner: {
    id: `${scope}.resultBanner`,
    defaultMessage: 'Tìm thấy <b>{found}/{total}</b> sản phẩm. Kiểm tra trước khi thêm vào giỏ hàng!',
  },
  selectAllHighConfidence: {
    id: `${scope}.selectAllHighConfidence`,
    defaultMessage: 'Chọn tất cả kết quả cao',
  },
  selectAllHighConfidenceSuccess: {
    id: `${scope}.selectAllHighConfidenceSuccess`,
    defaultMessage: 'Đã chọn kết quả với độ chính xác cao!',
  },
  recommendedProducts: {
    id: `${scope}.recommendedProducts`,
    defaultMessage: 'Sản phẩm đề xuất',
  },
  selectedHighConfidenceCount: {
    id: `${scope}.selectedHighConfidenceCount`,
    defaultMessage: 'Đã chọn {count} sản phẩm có độ chính xác cao',
  },
  columnUnitPrice: {
    id: `${scope}.columnUnitPrice`,
    defaultMessage: 'Đơn giá\n(trước VAT)',
  },
  columnConfidence: {
    id: `${scope}.columnConfidence`,
    defaultMessage: 'Độ chính xác',
  },
  columnQuantity: {
    id: `${scope}.columnQuantity`,
    defaultMessage: 'Số lượng',
  },
  confidenceHigh: {
    id: `${scope}.confidenceHigh`,
    defaultMessage: 'Cao',
  },
  confidenceMedium: {
    id: `${scope}.confidenceMedium`,
    defaultMessage: 'Trung bình',
  },
  confidenceLow: {
    id: `${scope}.confidenceLow`,
    defaultMessage: 'Thấp',
  },
  confidenceNone: {
    id: `${scope}.confidenceNone`,
    defaultMessage: 'Không tìm thấy',
  },
  purchasedTag: {
    id: `${scope}.purchasedTag`,
    defaultMessage: 'Đã mua',
  },
  changeProduct: {
    id: `${scope}.changeProduct`,
    defaultMessage: 'Đổi sản phẩm',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Tìm kiếm sản phẩm',
  },
  notFound: {
    id: `${scope}.notFound`,
    defaultMessage: 'Không tìm thấy',
  },
  searchManually: {
    id: `${scope}.searchManually`,
    defaultMessage: 'Tìm thủ công',
  },
  errorInvalidFormat: {
    id: `${scope}.errorInvalidFormat`,
    defaultMessage: 'Ảnh sai định dạng. Vui lòng tải ảnh theo định dạng JPEG/PNG/WEBP, dung lượng < 10MB.',
  },
  errorFileTooLarge: {
    id: `${scope}.errorFileTooLarge`,
    defaultMessage: 'Ảnh vượt quá dung lượng tối đa 10MB. Vui lòng chọn ảnh nhỏ hơn.',
  },
  errorTooManyFiles: {
    id: `${scope}.errorTooManyFiles`,
    defaultMessage: 'Chỉ hỗ trợ tối đa 3 ảnh. Vui lòng dán/tải ảnh lại.',
  },
  footerTotalLabel: {
    id: `${scope}.footerTotalLabel`,
    defaultMessage: 'Tổng tiền (Trước VAT)',
  },
  footerReanalyze: {
    id: `${scope}.footerReanalyze`,
    defaultMessage: 'Phân tích lại',
  },
  footerAddToCart: {
    id: `${scope}.footerAddToCart`,
    defaultMessage: 'Thêm {count} sản phẩm vào giỏ hàng',
  },
  footerAddToCartDisable: {
    id: `${scope}.footerAddToCartDisable`,
    defaultMessage: 'Thêm sản phẩm vào giỏ hàng',
  },
  suggest: {
    id: `${scope}.suggest`,
    defaultMessage: 'Gợi ý',
  },
  userInput: {
    id: `${scope}.userInput`,
    defaultMessage: 'Bạn nhập "{input}"',
  },
  addToCartSuccessfully: {
    id: `${scope}.addToCartSuccessfully`,
    defaultMessage: 'Đã thêm vào giỏ hàng!',
  },
  changeProductSuccessfully: {
    id: `${scope}.changeProductSuccessfully`,
    defaultMessage: 'Đã đổi sản phẩm!',
  },
});
